// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"12":"de6e7020","87":"1c742270","173":"1c742270","248":"1c742270","482":"1c742270","863":"1c742270"}[chunkId] + ".chunk.css";
};